import ClientLayout from 'spa/client/layouts/ClientLayout'
import CSSModules from 'react-css-modules'
import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { API } from 'javascripts/api'
import ClientQuestionnairesTable, { QuestionnaireTableProps } from 'spa/client/components/ClientQuestionnairesTable'
import { ContractExtensionRequest } from 'javascripts/api/generated'
import styles from './style.module.scss'

const ClientHome: React.FC = CSSModules<React.FC>(() => {
  const navigate = useNavigate()
  const [questionnaires, setQuestionnaires] = useState<ContractExtensionRequest[]>([])

  useEffect(() => {
    let alive = true

    API.getClientQuestionnaires(1, 'unanswered', 'expiresAt', 'asc').then(response => {
      if (alive) setQuestionnaires(response.data)
    }).catch(error => {
      if (API.isAxiosError(error)) {
        if (API.isUnauthorizedError(error.response)) {
          navigate('/client_auth/login', {
            state: {
              flash: { error: 'ログインしてください。' }
            }
          })
        }
      }
    })

    return () => { alive = false }
  }, [])

  const HomeQuestionnairesTable: React.FC<QuestionnaireTableProps> = CSSModules<React.FC<QuestionnaireTableProps>>((props) => {
    if (props.questionnaires.length) return <ClientQuestionnairesTable questionnaires={props.questionnaires} />
    return <p styleName="not-exist">確認する契約はありません。</p>
  }, styles)

  return (
    <ClientLayout>
      <div styleName="client-page-title">
        <h1>契約更新の確認</h1>
      </div>
      <div styleName="client-home-content">
        <HomeQuestionnairesTable questionnaires={questionnaires} />
      </div>
    </ClientLayout>
  )
}, styles)

export default ClientHome
